export const cardPage = {
    "cvv": "CVV",
    "expiry": "Expiry",
    "card_number": "Card number",
    "future_charge": "Your first charge will be at {{date}}",
    "total_payable": "Total payable",
    "payment_provider_error": "Payment provider internal error. Please wait a few seconds to allow to check if a charge has been made",
    "payment_error": "Payment error, please try again",
    "payment_error_with_response": "Payment error ({{response}}), please try again or check your card details",
};
